import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_eye.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_eye_disabled.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_f_whatsapp.svg'
import _imports_3 from '@/app/ui/assets/svg/ics_f_warning_circle.svg'


const _hoisted_1 = {
  "data-testid": "pickup-detail-sidebar",
  class: "pr-4"
}
const _hoisted_2 = { class: "bg-white p-4 rounded-xl border border-gray-lp-1600 space-y-4" }
const _hoisted_3 = {
  key: 0,
  "data-testid": "pickup-detail-sidebar-client-heading",
  class: "flex pb-4 border-b border-gray-lp-1600 items-center justify-between"
}
const _hoisted_4 = { class: "font-bold text-24px text-black-lp-100 break-words" }
const _hoisted_5 = { class: "flex pb-4 border-b border-gray-lp-1600 items-center justify-between" }
const _hoisted_6 = {
  "data-testid": "pickup-detail-sidebar-title",
  class: "font-bold text-16px text-black-lp-100"
}
const _hoisted_7 = { class: "space-y-1" }
const _hoisted_8 = {
  "data-testid": "pickup-detail-sidebar-created-at",
  class: "flex flex-col gap-y-0.5"
}
const _hoisted_9 = { class: "text-14px text-black-lp-100 font-normal" }
const _hoisted_10 = { class: "text-14px text-black-lp-100 font-semibold" }
const _hoisted_11 = {
  "data-testid": "pickup-detail-sidebar-created-by",
  class: "flex gap-y-0.5 "
}
const _hoisted_12 = { class: "text-14px text-gray-lp-3005 font-semibold" }
const _hoisted_13 = /*#__PURE__*/_createVNode("hr", { class: "border-gray-lp-400" }, null, -1)
const _hoisted_14 = {
  "data-testid": "pickup-detail-sidebar-courier-section",
  class: "space-y-2"
}
const _hoisted_15 = { class: "font-bold text-16px text-black-lp-100" }
const _hoisted_16 = { class: "text-14px text-black-lp-100 font-normal" }
const _hoisted_17 = {
  class: "text-14px text-black-lp-100 font-semibold",
  "data-testid": "pickup-detail-sidebar-courier-name"
}
const _hoisted_18 = {
  class: "flex items-center gap-x-2 text-12px text-black-lp-100 font-medium",
  "data-testid": "pickup-detail-sidebar-courier-id"
}
const _hoisted_19 = { class: "flex items-center gap-x-2 text-12px text-black-lp-100 font-medium" }
const _hoisted_20 = { "data-testid": "pickup-detail-sidebar-courier-phone" }
const _hoisted_21 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "WhatsApp",
  class: "w-4 h-4 inline-block"
}, null, -1)
const _hoisted_22 = {
  key: 1,
  "data-testid": "pickup-detail-sidebar-courier-empty",
  class: "text-12px font-normal text-gray-lp-3005"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "text-14px text-black-lp-100 font-normal" }
const _hoisted_25 = { class: "flex flex-row space-x-3 mt-2" }
const _hoisted_26 = {
  key: 2,
  class: "border-gray-lp-400"
}
const _hoisted_27 = { class: "flex flex-col gap-y-2" }
const _hoisted_28 = {
  key: 0,
  "data-testid": "pickup-detail-sidebar-merge-info",
  class: "space-y-2 mt-2"
}
const _hoisted_29 = { class: "flex items-start gap-x-3 p-3 bg-blue-lp-600 rounded-lg" }
const _hoisted_30 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  alt: "Info",
  class: "w-5 h-5 text-blue-lp-300 flex-shrink-0 mt-0.5"
}, null, -1)
const _hoisted_31 = { class: "flex-1 text-14px text-blue-lp-700" }
const _hoisted_32 = { class: "font-bold text-12px text-black-lp-100 mb-2.5" }
const _hoisted_33 = { class: "merge-shipment-list list-disc list-inside space-y-0.5 max-h-60 overflow-y-auto" }
const _hoisted_34 = {
  key: 1,
  "data-testid": "pickup-detail-sidebar-skeleton",
  class: "space-y-4 bg-white p-4 rounded-xl border border-gray-lp-1600"
}
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<div class=\"h-5 bg-gray-200 animate-pulse rounded w-1/3\"></div><div class=\"h-4 bg-gray-200 animate-pulse rounded w-1/2\"></div><div class=\"h-4 bg-gray-200 animate-pulse rounded w-1/3\"></div><div class=\"h-5 bg-gray-200 animate-pulse rounded w-1/4\"></div><div class=\"h-4 bg-gray-200 animate-pulse rounded w-1/3\"></div><div class=\"h-4 bg-gray-200 animate-pulse rounded w-1/4\"></div><div class=\"h-4 bg-gray-200 animate-pulse rounded w-1/5\"></div><div class=\"flex gap-2\"><div class=\"h-20 bg-gray-200 animate-pulse rounded w-20\"></div><div class=\"h-20 bg-gray-200 animate-pulse rounded w-20\"></div><div class=\"h-20 bg-gray-200 animate-pulse rounded w-20\"></div><div class=\"h-20 bg-gray-200 animate-pulse rounded w-20\"></div></div>", 8)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PickupStatusBadge = _resolveComponent("PickupStatusBadge")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_ImagePreview = _resolveComponent("ImagePreview")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("div", _hoisted_2, [
              (_ctx.showClientHeading)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _createVNode("h2", _hoisted_4, _toDisplayString(_ctx.clientRefDisplay), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_5, [
                _createVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("pickupV2.detailSidebar.statusPickUp")), 1),
                _createVNode(_component_PickupStatusBadge, {
                  "data-testid": "pickup-detail-status-badge",
                  statusCode: _ctx.statusCode
                }, null, 8, ["statusCode"])
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("pickupV2.detailSidebar.createdAt")), 1),
                  _createVNode("span", _hoisted_10, _toDisplayString(_ctx.createdAtLabel), 1)
                ]),
                _createVNode("div", _hoisted_11, [
                  _createVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("pickupV2.detailSidebar.by", { name: _ctx.createdByLabel })), 1)
                ])
              ]),
              _hoisted_13,
              _createVNode("div", _hoisted_14, [
                _createVNode("h4", _hoisted_15, _toDisplayString(_ctx.$t("pickupV2.detailSidebar.courierInfo")), 1),
                (_ctx.courierAvailable && _ctx.courierName)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("pickupV2.detailSidebar.courierName")), 1),
                      _createVNode("div", _hoisted_17, _toDisplayString(_ctx.courierName), 1),
                      _createVNode("div", _hoisted_18, [
                        _createVNode("span", null, _toDisplayString(_ctx.courierId), 1),
                        (!_ctx.phoneRevealed)
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              "data-testid": "pickup-detail-sidebar-courier-reveal-button",
                              src: _imports_0,
                              alt: _ctx.$t('pickupV2.detailSidebar.revealPhone'),
                              class: "w-4 h-4 cursor-pointer text-gray-lp-500 hover:text-gray-lp-300",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('reveal-phone')))
                            }, null, 8, ["alt"]))
                          : _createCommentVNode("", true),
                        (_ctx.phoneRevealed)
                          ? (_openBlock(), _createBlock("img", {
                              key: 1,
                              "data-testid": "pickup-detail-sidebar-courier-reveal-button",
                              src: _imports_1,
                              alt: _ctx.$t('pickupV2.detailSidebar.revealPhone'),
                              class: "w-4 h-4 cursor-pointer text-gray-lp-500 hover:text-gray-lp-300",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('reveal-phone')))
                            }, null, 8, ["alt"]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_19, [
                          _createVNode("span", _hoisted_20, _toDisplayString(_ctx.courierPhoneDisplay), 1),
                          (_ctx.phoneRevealed && _ctx.courierPhoneDisplay)
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                "data-testid": "pickup-detail-sidebar-courier-wa-button",
                                href: _ctx.waLink,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                class: "text-blue-lp-300 hover:underline"
                              }, [
                                _hoisted_21
                              ], 8, ["href"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 64))
                  : (_openBlock(), _createBlock("div", _hoisted_22, _toDisplayString(_ctx.$t("pickupV2.detailSidebar.courierNotAssigned")), 1))
              ]),
              (_ctx.displayedProofUrls.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_23, [
                    _createVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("pickupV2.detailSidebar.proofPhotos")), 1),
                    _createVNode("div", _hoisted_25, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.displayedProofUrls, (photo) => {
                        return (_openBlock(), _createBlock("div", {
                          key: photo,
                          class: "border border-gray-lp-1500 p-1 rounded-lg"
                        }, [
                          photo
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                src: photo,
                                alt: "photo",
                                class: "rounded-lg object-cover cursor-pointer",
                                style: {"height":"60px","width":"60px"},
                                onClick: () => _ctx.onPreview(photo)
                              }, null, 8, ["src", "onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.canShowCancelButton || _ctx.canPrintDhlLabel)
                ? (_openBlock(), _createBlock("hr", _hoisted_26))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_27, [
                (_ctx.canShowCancelButton)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 0,
                      "data-testid": "pickup-detail-cancel-button",
                      outline: "",
                      textColor: "red-lp-100",
                      title: _ctx.$t('pickup.cancel.button'),
                      isWidthFull: true,
                      onClick: _ctx.openCancelModal
                    }, null, 8, ["title", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.canPrintDhlLabel)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 1,
                      "data-testid": "pickup-detail-print-label-button",
                      color: "red-lp-100",
                      textColor: "white",
                      title: _ctx.$t('pickup.detail.printLabel'),
                      isWidthFull: true,
                      onClick: _ctx.onPrintLabel
                    }, null, 8, ["title", "onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.mergedShipments && _ctx.mergedShipments.length > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode("div", _hoisted_31, [
                      _withDirectives(_createVNode("span", null, null, 512), [
                        [_directive_sanitize_html, _ctx.$t('pickupV2.detailSidebar.sidebar.merge.infoMessage', {shipmentCount: `${_ctx.mergedShipments.length} ${_ctx.$t('pickupV2.detailSidebar.sidebar.merge.shipmentUnit')}`})]
                      ]),
                      _createVNode("a", {
                        "data-testid": "pickup-detail-sidebar-merge-view-link",
                        href: "javascript:void(0)",
                        class: "underline ml-1 cursor-pointer",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openOverlayPanel && _ctx.openOverlayPanel(...args)), ["stop"]))
                      }, _toDisplayString(_ctx.$t("pickupV2.detailSidebar.sidebar.merge.viewLink")), 1)
                    ])
                  ]),
                  _createVNode(_component_OverlayPanel, {
                    ref: _ctx.opKey,
                    appendTo: "body",
                    "data-testid": "pickup-detail-sidebar-merge-popover",
                    class: "merge-popover w-300px left-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode("div", null, [
                        _createVNode("h5", _hoisted_32, _toDisplayString(_ctx.$t("pickupV2.detailSidebar.sidebar.merge.listTitle")), 1),
                        _createVNode("ul", _hoisted_33, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mergedShipments, (item) => {
                            return (_openBlock(), _createBlock("li", {
                              key: item.shipmentId,
                              "data-testid": `pickup-detail-sidebar-merge-item-${item.shipmentId.toLowerCase()}`,
                              class: "text-12px text-black-lp-100"
                            }, _toDisplayString(_ctx.formatMergeItem(item)), 9, ["data-testid"]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _: 1
                  }, 512)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createBlock("div", _hoisted_34, [
            _hoisted_35
          ]))
    ]),
    _createVNode(_component_ImagePreview, {
      modelValue: _ctx.photoPreview,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.photoPreview = $event)),
      data: _ctx.photoPreviews,
      image: _ctx.photo,
      isTerm: false
    }, null, 8, ["modelValue", "data", "image"])
  ], 64))
}